import React, { useState } from 'react'


const Modal = (props) => {
    const [isOpen, setIsOpen] = useState(props.message != null);

    React.useEffect(() => {
        setIsOpen(props.message != null)
    }, props.message)

    return (

            <div
            id="booking-form-overlay"
            style={{
                width: isOpen ? "100%" : "0",
                zIndex: 999
            }}
            >
                <div className="form-container">
                    
                <div
              id="booking-form"
              className={`booking-form-container booking-form-container-${
                isOpen ? "expanded" : "collapsed"
              }`}
            >
                <div className="page-title">Error</div>
              <div className="booking-form-content">
                <div  className="modal_text">
                    {props.message}
                    </div>
                    <div
                    className="purple-button"
                    onClick={() =>{
                        setIsOpen(false);
                        props.onClose();
                    }
                    }
                  >
                    Close
                  </div>
                  </div>
                  </div>
                </div>
                
            </div>
        
    )

}

export default Modal